import { isUnitedStatesCountry } from "./sales-order-charge-lines.js";

export const DEFAULT_SALES_ORDER_COUNTRY_CODE = "US";

export const SALES_ORDER_COUNTRY_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "US", label: "United States" },
  { value: "CA", label: "Canada" },
  { value: "MX", label: "Mexico" },
  { value: "GB", label: "United Kingdom" },
  { value: "IE", label: "Ireland" },
  { value: "AU", label: "Australia" },
  { value: "NZ", label: "New Zealand" },
  { value: "DE", label: "Germany" },
  { value: "FR", label: "France" },
  { value: "ES", label: "Spain" },
  { value: "IT", label: "Italy" },
  { value: "NL", label: "Netherlands" },
  { value: "BE", label: "Belgium" },
  { value: "CH", label: "Switzerland" },
  { value: "AT", label: "Austria" },
  { value: "SE", label: "Sweden" },
  { value: "NO", label: "Norway" },
  { value: "DK", label: "Denmark" },
  { value: "FI", label: "Finland" },
  { value: "PL", label: "Poland" },
  { value: "PT", label: "Portugal" },
  { value: "JP", label: "Japan" },
  { value: "KR", label: "South Korea" },
  { value: "CN", label: "China" },
  { value: "TW", label: "Taiwan" },
  { value: "HK", label: "Hong Kong" },
  { value: "SG", label: "Singapore" },
  { value: "IN", label: "India" },
  { value: "PH", label: "Philippines" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "IL", label: "Israel" },
  { value: "ZA", label: "South Africa" },
  { value: "BR", label: "Brazil" },
  { value: "AR", label: "Argentina" },
  { value: "CL", label: "Chile" },
  { value: "CO", label: "Colombia" },
  { value: "CR", label: "Costa Rica" },
  { value: "PA", label: "Panama" },
  { value: "GT", label: "Guatemala" },
];

export type SalesOrderRegionEntry = { value: string; name: string };

export const SALES_ORDER_US_REGION_ENTRIES: SalesOrderRegionEntry[] = [
  { value: "AL", name: "Alabama" },
  { value: "AK", name: "Alaska" },
  { value: "AZ", name: "Arizona" },
  { value: "AR", name: "Arkansas" },
  { value: "CA", name: "California" },
  { value: "CO", name: "Colorado" },
  { value: "CT", name: "Connecticut" },
  { value: "DE", name: "Delaware" },
  { value: "DC", name: "District of Columbia" },
  { value: "FL", name: "Florida" },
  { value: "GA", name: "Georgia" },
  { value: "HI", name: "Hawaii" },
  { value: "ID", name: "Idaho" },
  { value: "IL", name: "Illinois" },
  { value: "IN", name: "Indiana" },
  { value: "IA", name: "Iowa" },
  { value: "KS", name: "Kansas" },
  { value: "KY", name: "Kentucky" },
  { value: "LA", name: "Louisiana" },
  { value: "ME", name: "Maine" },
  { value: "MD", name: "Maryland" },
  { value: "MA", name: "Massachusetts" },
  { value: "MI", name: "Michigan" },
  { value: "MN", name: "Minnesota" },
  { value: "MS", name: "Mississippi" },
  { value: "MO", name: "Missouri" },
  { value: "MT", name: "Montana" },
  { value: "NE", name: "Nebraska" },
  { value: "NV", name: "Nevada" },
  { value: "NH", name: "New Hampshire" },
  { value: "NJ", name: "New Jersey" },
  { value: "NM", name: "New Mexico" },
  { value: "NY", name: "New York" },
  { value: "NC", name: "North Carolina" },
  { value: "ND", name: "North Dakota" },
  { value: "OH", name: "Ohio" },
  { value: "OK", name: "Oklahoma" },
  { value: "OR", name: "Oregon" },
  { value: "PA", name: "Pennsylvania" },
  { value: "PR", name: "Puerto Rico" },
  { value: "RI", name: "Rhode Island" },
  { value: "SC", name: "South Carolina" },
  { value: "SD", name: "South Dakota" },
  { value: "TN", name: "Tennessee" },
  { value: "TX", name: "Texas" },
  { value: "UT", name: "Utah" },
  { value: "VT", name: "Vermont" },
  { value: "VA", name: "Virginia" },
  { value: "VI", name: "U.S. Virgin Islands" },
  { value: "WA", name: "Washington" },
  { value: "WV", name: "West Virginia" },
  { value: "WI", name: "Wisconsin" },
  { value: "WY", name: "Wyoming" },
  { value: "GU", name: "Guam" },
  { value: "AS", name: "American Samoa" },
  { value: "MP", name: "Northern Mariana Islands" },
];

export const SALES_ORDER_CA_REGION_ENTRIES: SalesOrderRegionEntry[] = [
  { value: "AB", name: "Alberta" },
  { value: "BC", name: "British Columbia" },
  { value: "MB", name: "Manitoba" },
  { value: "NB", name: "New Brunswick" },
  { value: "NL", name: "Newfoundland and Labrador" },
  { value: "NS", name: "Nova Scotia" },
  { value: "NT", name: "Northwest Territories" },
  { value: "NU", name: "Nunavut" },
  { value: "ON", name: "Ontario" },
  { value: "PE", name: "Prince Edward Island" },
  { value: "QC", name: "Quebec" },
  { value: "SK", name: "Saskatchewan" },
  { value: "YT", name: "Yukon" },
];

export const SALES_ORDER_MX_REGION_ENTRIES: SalesOrderRegionEntry[] = [
  { value: "AG", name: "Aguascalientes" },
  { value: "BC", name: "Baja California" },
  { value: "BS", name: "Baja California Sur" },
  { value: "CM", name: "Campeche" },
  { value: "CS", name: "Chiapas" },
  { value: "CH", name: "Chihuahua" },
  { value: "CO", name: "Coahuila" },
  { value: "CL", name: "Colima" },
  { value: "CX", name: "Mexico City" },
  { value: "DG", name: "Durango" },
  { value: "GT", name: "Guanajuato" },
  { value: "GR", name: "Guerrero" },
  { value: "HG", name: "Hidalgo" },
  { value: "JA", name: "Jalisco" },
  { value: "EM", name: "Mexico" },
  { value: "MI", name: "Michoacan" },
  { value: "MO", name: "Morelos" },
  { value: "NA", name: "Nayarit" },
  { value: "NL", name: "Nuevo Leon" },
  { value: "OA", name: "Oaxaca" },
  { value: "PU", name: "Puebla" },
  { value: "QT", name: "Queretaro" },
  { value: "QR", name: "Quintana Roo" },
  { value: "SL", name: "San Luis Potosi" },
  { value: "SI", name: "Sinaloa" },
  { value: "SO", name: "Sonora" },
  { value: "TB", name: "Tabasco" },
  { value: "TM", name: "Tamaulipas" },
  { value: "TL", name: "Tlaxcala" },
  { value: "VE", name: "Veracruz" },
  { value: "YU", name: "Yucatan" },
  { value: "ZA", name: "Zacatecas" },
];

export const SALES_ORDER_AU_REGION_ENTRIES: SalesOrderRegionEntry[] = [
  { value: "ACT", name: "Australian Capital Territory" },
  { value: "NSW", name: "New South Wales" },
  { value: "NT", name: "Northern Territory" },
  { value: "QLD", name: "Queensland" },
  { value: "SA", name: "South Australia" },
  { value: "TAS", name: "Tasmania" },
  { value: "VIC", name: "Victoria" },
  { value: "WA", name: "Western Australia" },
];

export type SalesOrderRegionField = {
  kind: "select" | "text";
  regionLabel: string;
  regionPlaceholder: string;
  postalLabel: string;
  entries: SalesOrderRegionEntry[];
};

const US_REGION_FIELD: SalesOrderRegionField = {
  kind: "select",
  regionLabel: "State",
  regionPlaceholder: "Select state",
  postalLabel: "Zip",
  entries: SALES_ORDER_US_REGION_ENTRIES,
};

const REGION_BY_COUNTRY: Record<string, SalesOrderRegionField> = {
  US: US_REGION_FIELD,
  CA: {
    kind: "select",
    regionLabel: "Province",
    regionPlaceholder: "Select province",
    postalLabel: "Postal code",
    entries: SALES_ORDER_CA_REGION_ENTRIES,
  },
  MX: {
    kind: "select",
    regionLabel: "State",
    regionPlaceholder: "Select state",
    postalLabel: "Postal code",
    entries: SALES_ORDER_MX_REGION_ENTRIES,
  },
  AU: {
    kind: "select",
    regionLabel: "State",
    regionPlaceholder: "Select state",
    postalLabel: "Postal code",
    entries: SALES_ORDER_AU_REGION_ENTRIES,
  },
  GB: {
    kind: "text",
    regionLabel: "County",
    regionPlaceholder: "County",
    postalLabel: "Postal code",
    entries: [],
  },
};

const DEFAULT_INTERNATIONAL_REGION_FIELD: SalesOrderRegionField = {
  kind: "text",
  regionLabel: "Region",
  regionPlaceholder: "Region",
  postalLabel: "Postal code",
  entries: [],
};

const COUNTRY_ALIASES: Record<string, string> = {
  USA: "US",
  "UNITED STATES": "US",
  "UNITED STATES OF AMERICA": "US",
  CANADA: "CA",
  MEXICO: "MX",
  UK: "GB",
  "UNITED KINGDOM": "GB",
  "GREAT BRITAIN": "GB",
  AUSTRALIA: "AU",
};

/** Canonical hub country code for persisted ship/bill addresses (empty stays empty). */
export function normalizeHubStoredShipToCountry(value: string | null | undefined): string {
  const trimmed = String(value ?? "").trim();
  if (trimmed === "") {
    return "";
  }
  return normalizeSalesOrderCountryCode(trimmed);
}

/**
 * Megaventory mirror on `public.sales_order` (*_country text).
 * Blank MV country stays blank in text (US is implied via `*_country_code` when `mv_id` is set).
 * Non-blank values normalize to hub ISO codes where possible.
 */
export function normalizeMegaventoryMirroredCountry(value: string | null | undefined): string {
  const trimmed = String(value ?? "").trim();
  if (trimmed === "") {
    return "";
  }
  return normalizeHubStoredShipToCountry(trimmed);
}

/**
 * SQL expression matching {@link normalizeHubStoredShipToCountry} for batch / sales_order ship-to equality.
 * Blank and ERP sentinels map to US; long domestic names map to ISO codes.
 */
export function hubShipToCountrySqlNormalized(columnSql: string): string {
  return `coalesce(reference.resolve_country_code(${columnSql}), 'US')`;
}

function normalizeCountryToken(value: string | null | undefined): string {
  return String(value ?? "")
    .trim()
    .toUpperCase()
    .replace(/\./g, "")
    .replace(/\s+/g, " ");
}

/** Canonical hub country code for sales order ship/bill addresses. */
export function normalizeSalesOrderCountryCode(value: string | null | undefined): string {
  const token = normalizeCountryToken(value);
  if (token === "" || token === "NONE" || token === "N/A" || token === "NA") {
    return DEFAULT_SALES_ORDER_COUNTRY_CODE;
  }
  const aliased = COUNTRY_ALIASES[token];
  if (aliased != null) {
    return aliased;
  }
  const known = SALES_ORDER_COUNTRY_OPTIONS.find((option) => option.value === token);
  if (known != null) {
    return known.value;
  }
  const byLabel = SALES_ORDER_COUNTRY_OPTIONS.find((option) => normalizeCountryToken(option.label) === token);
  if (byLabel != null) {
    return byLabel.value;
  }
  return String(value ?? "").trim();
}

export function isUnitedStatesSalesOrderCountry(value: string | null | undefined): boolean {
  const token = normalizeCountryToken(value);
  if (token === "NONE" || token === "N/A" || token === "NA") {
    return true;
  }
  return isUnitedStatesCountry(value);
}

export function salesOrderRegionField(country: string | null | undefined): SalesOrderRegionField {
  const code = normalizeSalesOrderCountryCode(country);
  if (isUnitedStatesSalesOrderCountry(code)) {
    return US_REGION_FIELD;
  }
  return REGION_BY_COUNTRY[code] ?? DEFAULT_INTERNATIONAL_REGION_FIELD;
}

export function normalizeSalesOrderRegionInput(
  country: string | null | undefined,
  value: string | null | undefined,
): string {
  const trimmed = (value ?? "").trim();
  if (trimmed === "") {
    return "";
  }
  const field = salesOrderRegionField(country);
  if (field.kind !== "select" || field.entries.length === 0) {
    return trimmed;
  }
  const upper = trimmed.toUpperCase();
  const byCode = field.entries.find((entry) => entry.value === upper);
  if (byCode != null) {
    return byCode.value;
  }
  const byName = field.entries.find((entry) => entry.name.toLowerCase() === trimmed.toLowerCase());
  return byName?.value ?? trimmed;
}

/** When the operator changes country, drop a region that is not valid for the new list. */
export function regionAfterSalesOrderCountryChange(
  nextCountry: string | null | undefined,
  currentRegion: string | null | undefined,
): string {
  const field = salesOrderRegionField(nextCountry);
  const normalized = normalizeSalesOrderRegionInput(nextCountry, currentRegion);
  if (normalized === "") {
    return "";
  }
  if (field.kind === "select" && !field.entries.some((entry) => entry.value === normalized)) {
    return "";
  }
  return normalized;
}

/** Hub sales-order ship/bill free-text address lines are stored in ALL CAPS. */
export function coerceSalesOrderAddressText(value: string | null | undefined): string {
  return String(value ?? "").toUpperCase();
}

export function parseSalesOrderAddressTextField(value: unknown): string | null {
  if (typeof value !== "string") {
    return null;
  }
  const trimmed = value.trim();
  if (trimmed === "") {
    return null;
  }
  return trimmed.toUpperCase();
}

export function parseSalesOrderAddressStateField(
  country: string | null | undefined,
  value: unknown,
): string | null {
  const normalized = normalizeSalesOrderRegionInput(country, typeof value === "string" ? value : "");
  const trimmed = normalized.trim();
  if (trimmed === "") {
    return null;
  }
  return trimmed.toUpperCase();
}

export function parseSalesOrderAddressCountryField(value: unknown): string | null {
  if (typeof value !== "string") {
    return null;
  }
  const trimmed = value.trim();
  if (trimmed === "") {
    return null;
  }
  return normalizeSalesOrderCountryCode(trimmed);
}

/** Omit domestic country on customer-facing sales order PDFs. */
export function salesOrderPdfAddressCountry(value: string | null | undefined): string | null {
  if (isUnitedStatesSalesOrderCountry(value)) {
    return null;
  }
  const normalized = normalizeSalesOrderCountryCode(value);
  const known = SALES_ORDER_COUNTRY_OPTIONS.find((option) => option.value === normalized);
  if (known != null) {
    return known.label.toUpperCase();
  }
  const trimmed = String(value ?? "").trim();
  return trimmed === "" ? null : trimmed.toUpperCase();
}
